module.exports = __webpack_public_path__ + "img/collaboration.1da6dd2e.svg";